import React from 'react';
import { Button } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { getPeriodStatus } from './pure';

export async function copyToClipBoard(text) {
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      console.log("text copied successfully! \n", text);
    } catch (error) {
      console.log(error);
      alert("browser is not compatible");
    }
  } else {
    // text area method
    let textArea = document.createElement("textarea");
    textArea.value = text;
    // make the textarea out of viewport
    textArea.style.position = "fixed";
    textArea.style.left = "-999999px";
    textArea.style.top = "-999999px";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      // here the magic happens
      document.execCommand("copy");
      textArea.remove();
    } catch (error) {
      alert("browser is not compatible");
      console.log(error);
    }
  }
}

export const createErrorMessage = (error) => {
  let text = "";

  if (error?.data?.message) {
    text = error.data.message;
  } else if (error?.data?.error) {
    text = error.data.error;
  } else if (error?.error) {
    text = error.error;
  } else if (error?.message) {
    text = error.message;
  } else if (typeof error === "string") {
    text = error;
  } else {
    text = "An error occurred";
  }

  return(
    <>
      <div>{text}</div>
      <Button
        color="primary"
        variant="outlined"
        style={{ margin: '8px 0' }}
        onClick={() => {
          copyToClipBoard(text)
        }}
        endIcon={<ContentCopyIcon />}
      >
        Copy correlation ID
      </Button>
    </>
  )
}

export const getPeriodStatusComp = (obj) => {
  let statusName = getPeriodStatus(obj);
  switch (statusName) {
    case "COMPLETED":
      return <span style={{color: "green", fontWeight:'600'}}>COMPLETED</span>;
    case "CURRENT":
      return <span style={{color: "orange", fontWeight:'600'}}>CURRENT</span>;
    case "PENDING":
      return <span style={{color: "var(--amber)", fontWeight:'600'}}>PENDING</span>;
    default:
      return null;
  }
}
